import { Spinner } from '@heroui/react';

const PulseLoader = ({ title }: { title: string }) => {
    return (
        <div className="flex h-96 w-full items-center justify-center">
            <div className="flex animate-pulse flex-col items-center">
                <div className="flex gap-1 font-medium text-foreground/50">
                    {`Loading`} {title}
                    <Spinner variant="wave" size="sm" color="primary" className="mb-3" />
                </div>
            </div>
        </div>
    );
};

export default PulseLoader;
